import React from "react";
import { useContext } from "react"
import { PatientProfilePageContext } from "./context";

export const usePatientProfilePage = () => {
    const context = useContext(PatientProfilePageContext);

    if (!context)    
      throw new Error('usePatientProfilePage must be used within a PatientProfilePageProvider');
    
    return context;
}
